/* eslint-disable */

import * as runtime from '../runtime';
import type {
  ACHSetupIntentResponseDto,
  AddGuestPaymentMethodDto,
  ChargeMultipleProductsDto,
  ChargeProductResultDto,
  CreateGuestACHSetupIntentDto,
  CreateGuestRosterDto,
  CreateGuestRosterResponseDto,
  CreateMemberACHSetupIntentDto,
  PaymentMethodDto,
} from '../models';

export interface CreateGuestRosterForCheckoutRequest {
  orgId: number;
  createGuestRosterDto: CreateGuestRosterDto;
}

export interface CreateGuestACHSetupIntentRequest {
  orgId: number;
  createGuestACHSetupIntentDto: CreateGuestACHSetupIntentDto;
}

export interface CreateMemberACHSetupIntentRequest {
  orgId: number;
  createMemberACHSetupIntentDto: CreateMemberACHSetupIntentDto;
}

export interface ChargeMultipleProductsGuestRequest {
  orgId: number;
  chargeMultipleProductsDto: ChargeMultipleProductsDto;
}

export interface GetMultipleChargeTotalGuestRequest {
  orgId: number;
  chargeMultipleProductsDto: ChargeMultipleProductsDto;
}

export interface AddPaymentMethodGuestRequest {
  orgId: number;
  addGuestPaymentMethodDto: AddGuestPaymentMethodDto;
}

export interface ChargeMultipleProductsRequest {
  orgId: number;
  chargeMultipleProductsDto: ChargeMultipleProductsDto;
}

export interface GetMultipleChargeTotalRequest {
  orgId: number;
  chargeMultipleProductsDto: ChargeMultipleProductsDto;
}

export interface AddPaymentMethodRequest {
  rosterId: number;
  paymentMethodDto: PaymentMethodDto;
}

export class RosterApi extends runtime.BaseAPI {

  async createGuestRosterForCheckout(requestParameters: CreateGuestRosterForCheckoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateGuestRosterResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/org/${encodeURIComponent(String(requestParameters.orgId))}/roster/create-guest`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.createGuestRosterDto,
    }, initOverrides);
    return response.json();
  }

  async createGuestACHSetupIntent(requestParameters: CreateGuestACHSetupIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACHSetupIntentResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/org/${encodeURIComponent(String(requestParameters.orgId))}/roster/ach-setup-intent-guest`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.createGuestACHSetupIntentDto,
    }, initOverrides);
    return response.json();
  }

  async createMemberACHSetupIntent(requestParameters: CreateMemberACHSetupIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACHSetupIntentResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/org/${encodeURIComponent(String(requestParameters.orgId))}/roster/ach-setup-intent-member`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.createMemberACHSetupIntentDto,
    }, initOverrides);
    return response.json();
  }

  async chargeMultipleProductsGuest(requestParameters: ChargeMultipleProductsGuestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChargeProductResultDto>> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/org/${encodeURIComponent(String(requestParameters.orgId))}/roster/packages/charge-multiple-guest`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.chargeMultipleProductsDto,
    }, initOverrides);
    return response.json();
  }

  async getMultipleChargeTotalGuest(requestParameters: GetMultipleChargeTotalGuestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChargeProductResultDto>> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/org/${encodeURIComponent(String(requestParameters.orgId))}/roster/packages/charge-multiple-total-guest`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.chargeMultipleProductsDto,
    }, initOverrides);
    return response.json();
  }

  async addPaymentMethodGuest(requestParameters: AddPaymentMethodGuestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PaymentMethodDto>> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/org/${encodeURIComponent(String(requestParameters.orgId))}/roster/payment-methods-guest`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.addGuestPaymentMethodDto,
    }, initOverrides);
    return response.json();
  }

  async chargeMultipleProducts(requestParameters: ChargeMultipleProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChargeProductResultDto>> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/org/${encodeURIComponent(String(requestParameters.orgId))}/roster/packages/charge-multiple`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.chargeMultipleProductsDto,
    }, initOverrides);
    return response.json();
  }

  async getMultipleChargeTotal(requestParameters: GetMultipleChargeTotalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChargeProductResultDto>> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/org/${encodeURIComponent(String(requestParameters.orgId))}/roster/packages/charge-multiple-total`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.chargeMultipleProductsDto,
    }, initOverrides);
    return response.json();
  }

  async addPaymentMethod(requestParameters: AddPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PaymentMethodDto>> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/roster/${encodeURIComponent(String(requestParameters.rosterId))}/payment-history`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.paymentMethodDto,
    }, initOverrides);
    return response.json();
  }

}
